window.onload = function () {


};

// ページの読み込みと解析が完了した後に有効になる処理を記述
window.addEventListener('DOMContentLoaded', function (e) {

    // 送り先コンボボックスの更新
    function SituationComboUpdate() {
        var situations = '<select name="select[situation]" id="select_situation"><option value="">--</option>';
        for (var i = 0; i < data.situations.length; i++) {
            if (data.situations[i].scene_id == $('#select_scene').val()) {
                situations += '<option value=\"' + data.situations[i].id + '\">' + data.situations[i].name + '</option>';
            }
        }
        situations += '</select>';
        console.log(situations);
        $('#select_situation').replaceWith(situations);
    }

    // 電報種別コンボボックス変更時
    $(document).on('change', '#select_type', function () {

        // シーンコンボボックスの更新
        var scenes = '<select name="select[scene]" id="select_scene"><option value="">--</option>';
        for (var i = 0; i < data.scenes.length; i++) {
            if (data.scenes[i].telegram_type_id == $('#select_type').val()) {
                scenes += '<option value=\"' + data.scenes[i].id + '\">' + data.scenes[i].name + '</option>';
            }
        }
        scenes += '</select>';
        console.log(scenes);
        $('#select_scene').replaceWith(scenes);
        SituationComboUpdate();
    });

    // シーンコンボボックス変更時
    $(document).on('change', '#select_scene', function () {
        SituationComboUpdate();
    });

    // 電報種別ID から URL NAME を取得
    function getUrlNameByTelegramTypeId(id) {
        for (var i = 0; i < data.telegramTypes.length; i++) {
            if (data.telegramTypes[i].id == id) {
                return data.telegramTypes[i].url_name;
            }
        }
    }

    // シーンID から URL NAME を取得
    function getUrlNameBySceneId(id) {
        for (var i = 0; i < data.scenes.length; i++) {
            if (data.scenes[i].id == id) {
                return data.scenes[i].url_name;
            }
        }
    }

    // 検索ボタンを押したときの処理
    $(document).on('click', '#execute_search', function () {

        let to_url;

        to_url = window.location.protocol + '//' + window.location.host + '/example';
        console.log('base url:' + to_url);

        if ($('#select_type').val()) {
            to_url = to_url + '/' + getUrlNameByTelegramTypeId($('#select_type').val()) + '/';
        }

        if ($('#select_scene').val()) {
            to_url = to_url + getUrlNameBySceneId($('#select_scene').val()) + '/';
        }

        if ($('#select_situation').val()) {
            to_url = to_url + $('#select_situation').val() + '/';
        }

        console.log('goto ' + to_url);
        window.location.href = to_url;
    });
});
